import React from 'react';
import { Link } from 'react-router-dom';
import QuoteForm from '../QuoteForm/QuoteForm';

import get1 from '../../images/get1.png';
import get2 from '../../images/get2.svg';
import get3 from '../../images/get3.svg';
import get4 from '../../images/get4.png';

const GetQuateSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={'' + props.hclass}>
      <div className='container'>
        <div className='row align-items-center'>
          <div className='col-lg-6 col-12'>
            <div className='left-content'>
              <div className='wpo-section-title'>
                <h2>Request a Shipping Quote</h2>
                <h3>Reliable logistics solutions for every shipment</h3>
              </div>

              <div className='quat'>
                <p>
                  Ferry Gold Shipping provides flexible freight solutions across
                  road, air, ocean, and warehousing. Share your shipment details
                  with us and our team will help you choose the right logistics
                  option.
                </p>
              </div>

              <ul className='get-item'>
                <li>
                  <i className='flaticon-logistics'></i>
                  <h3>Domestic and International Freight Services</h3>
                </li>

                <li>
                  <i className='flaticon-nanotechnology'></i>
                  <h3>Smooth Shipment Handling and Support</h3>
                </li>
              </ul>

              <ul className='quate-item'>
                <li>
                  <i className='flaticon-check'></i>
                  <h3>Road, Air, and Ocean Freight</h3>
                </li>

                <li>
                  <i className='flaticon-check'></i>
                  <h3>Warehousing and Distribution</h3>
                </li>
              </ul>

              <Link onClick={ClickHandler} to='/about' className='theme-btn'>
                more about us
              </Link>
            </div>
          </div>

          <div className='col-lg-6 col-12'>
            <div className='quote-form'>
              <div className='title'>
                <h3>Request a Quote</h3>
              </div>

              <QuoteForm />
            </div>
          </div>
        </div>
      </div>

      <div className='left-bg'>
        <div className='img1'>
          <img src={get1} alt='' />
        </div>
        <div className='img2'>
          <img src={get2} alt='' />
        </div>
        <div className='img3'>
          <img src={get3} alt='' />
        </div>
      </div>

      <div className='rigth-bg'>
        <img src={get4} alt='' />
      </div>
    </section>
  );
};

export default GetQuateSection;
